import { Base } from '@studiometa/js-toolkit';

/**
 * Quantity Input Class
 */
export default class QuantityInput extends Base {
  quantityUpdateUnsubscriber = undefined;

  /**
   * Component Configuration
   */
  static config = {
    name: 'QuantityInput',
    refs: ['input', 'btn[]'],
  };

  /**
   * mounted
   */
  mounted() {
    this.changeEvent = new Event('change', { bubbles: true });
    this.validateQtyRules();
  }

  /**
   * destroyed
   */
  destroyed() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  /**
   * onInputchange
   */
  onInputChange() {
    this.validateQtyRules();
  }

  /**
   * onBtnClick
   * @param {*} event
   */
  onBtnClick({ event }) {
    event.preventDefault();
    const previousValue = this.$refs.input.value;

    event.target.name === 'plus' ? this.$refs.input.stepUp() : this.$refs.input.stepDown();
    if (previousValue !== this.$refs.input.value) {
      this.$refs.input.dispatchEvent(this.changeEvent);
    }
  }

  /**
   * validateQtyRules
   */
  validateQtyRules() {
    const value = Number.parseInt(this.$refs.input.value, 10);
    document.querySelector('#ajax-quantity').value = value;

    if (this.$refs.input.min) {
      const min = Number.parseInt(this.$refs.input.min, 10);
      const buttonMinus = this.$el.querySelector(".quantity__button[name='minus']");
      if (buttonMinus) {
        buttonMinus.classList.toggle('disabled', value <= min);
      }
    }

    if (this.$refs.input.max) {
      const max = Number.parseInt(this.$refs.input.max, 10);
      const buttonPlus = this.$el.querySelector(".quantity__button[name='plus']");
      if (buttonPlus) {
        buttonPlus.classList.toggle('disabled', value >= max);
      }
    }
  }
}
